/** @jsx jsx */
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { CALCULATED_LINE_HEIGHT_OFFSET } from 'styles/variables';

const findUl = node => {
  if (node === document.body) {
    return;
  }

  if (node.parentNode.tagName.toLowerCase() === 'ul') {
    return node.parentNode;
  }

  return findUl(node.parentNode);
};

const Indent = ({ type, attributes, children }) => {
  const indent: any = useRef(null);

  useLayoutEffect(() => {
    const foundUl = findUl(indent.current.parentNode);

    let closestLi;
    if (foundUl) {
      closestLi = indent.current.closest('li');
      if (closestLi) {
        closestLi.classList.add('indent');
      }
    } else {
      indent.current.classList.add('indent-alt');
    }

    return () => {
      closestLi?.classList.remove('indent');
      indent.current.classList.remove('indent-alt');
    };
  }, []);

  useEffect(() => {
    requestAnimationFrame(() => {
      const foundUl = findUl(indent.current.parentNode);

      if (!foundUl && indent.current.classList.contains('indent-alt')) {
        console.log('kill it with fire !!!');
      }
    });
  }, []);

  return (
    <span ref={indent} data-type={type} {...attributes}>
      {children}
    </span>
  );
};

const Lang = ({ type, lang, attributes, children }) => {
  const langRef: any = useRef(null);

  if (!lang) {
    return children;
  }

  return (
    <span>
      <span
        ref={langRef}
        className="lang-bracket"
        data-type={type}
        {...attributes}
      >
        {children}
      </span>
      {lang && (
        <sup
          style={{
            fontSize: 11,
          }}
        >
          *{lang}
        </sup>
      )}
    </span>
  );
};

const renderMark = (props, editor, next) => {
  const { children, mark, attributes } = props;
  const { type, data } = mark;

  switch (type) {
    case 'bold':
      return <strong {...attributes}>{children}</strong>;
    case 'italic':
      return <em {...attributes}>{children}</em>;
    case 'underline':
      return <u {...attributes}>{children}</u>;

    case 'fontFamily':
      const fontFamily = data.get('fontFamily');

      return (
        <span style={{ fontFamily }} data-type={type} {...attributes}>
          {children}
        </span>
      );

    case 'fontSize':
      const fontSize = parseInt(data.get('fontSize'), 10);
      const calculatedLineHeight =
        fontSize <= 18 ? 1.5 : fontSize * CALCULATED_LINE_HEIGHT_OFFSET;

      return (
        <span
          style={{
            fontSize,
            lineHeight: `${calculatedLineHeight}px`,
          }}
          data-type={type}
          {...attributes}
        >
          {children}
        </span>
      );

    case 'color':
      return (
        <span
          style={{ color: data.get('color') }}
          data-type={type}
          {...attributes}
        >
          {children}
        </span>
      );

    case 'lang':
      const lang = data.get('lang');

      // if (!children?.props?.text) {
      //   return null;
      // }
      //

      return (
        <Lang type={type} lang={lang} {...attributes}>
          {children}
        </Lang>
      );

    case 'indent': {
      return (
        <Indent type={type} attributes={attributes}>
          {children}
        </Indent>
      );
    }

    case 'superscript': {
      return (
        <sup data-type={type} {...attributes}>
          {children}
        </sup>
      );
    }

    case 'subscript': {
      return (
        <sub data-type={type} {...attributes}>
          {children}
        </sub>
      );
    }

    default:
      return next();
  }
};

export default renderMark;
